module.exports = __webpack_public_path__ + "static/media/default.52537dc1.ico";